// Translations
import information from '../sections/information/translations/tr'
import password from '../sections/password/translations/tr'
import phoneNumber from '../sections/phone-number/translations/tr'

// Translation: Account > Settings (Turkish)
export default Object.freeze({
	header: {
		subtitle: 'Buradan hesap ayarlarını yönetin',
		title: 'Hesap ayarları'
	},
	sections: { information, password, phoneNumber }
})
